module.exports = __webpack_public_path__ + "media/img/specialize/specialize_bg-2a7a9be9f0a2b1c8573a3d618b98ee2b.jpg";